module.exports = __webpack_public_path__ + "images/xl_dychess.png?81625e822fcb7c9799a0ef83a9f00074";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_dychess.png
// module id = 233
// module chunks = 1